import { ManagedUserRoles } from "@redotech/account-common/roles";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { RedoNotificationBanner } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { memo, useContext } from "react";
import { useLocalStorage } from "usehooks-ts";

const HOLIDAY_SURCHARGES_PDF_URL =
  "https://assets.getredo.com/shipping/2026-carrier-holiday-surcharges.pdf";

export const HolidaySurchargesBanner = memo(function HolidaySurchargesBanner() {
  const [dismissed, setDismissed] = useLocalStorage<boolean>(
    "holiday-surcharges-2026-dismissed",
    false,
  );
  const user = useContext(UserContext);

  const isAdmin =
    user?.managedUserRoles?.includes(ManagedUserRoles.ADMIN) ?? false;

  if (dismissed || !isAdmin) {
    return null;
  }

  return (
    <RedoNotificationBanner
      items={[
        {
          id: "holiday-surcharges-2026",
          type: "info",
          message:
            "Plan ahead for peak: Carriers have announced their 2026 holiday surcharges, and some are already in effect.",
          actions: [
            {
              actionType: "link",
              text: "See the surcharges",
              href: HOLIDAY_SURCHARGES_PDF_URL,
              target: "_blank",
              internal: false,
            },
          ],
        },
      ]}
      onDismiss={() => setDismissed(true)}
    />
  );
});
